import api from '@/api';

export default {
  data() {
    return {
      updatingSubscription: false,
    };
  },
  methods: {
    async updateSubscription() {
      try {
        this.updatingSubscription = true;
        const sessionId = await api.subscription.update();
        const stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);
        await stripe.redirectToCheckout({ sessionId });
      } catch (error) {
        this.$notifications.error(error.message);
        throw error;
      } finally {
        this.updatingSubscription = false;
      }
    },
  },
};
